import type { Logger } from "@expert/logging";

import { getCustomerDetailsApi } from "./api";

interface UpdateCaseRequestBody {
    caseId: string;
    subject: string;
    description: string;
    category?: string;
    subcategory?: string;
}

export const updateCase = async (
    logger: Logger,
    request: UpdateCaseRequestBody,
): Promise<{ caseId: string; caseNumber: string } | null> => {
    try {
        const client = getCustomerDetailsApi();
        const apiPath = `v1/case/${request.caseId}`;
        return await client.post(apiPath, { json: request, retry: 0 }).json<{ caseId: string; caseNumber: string }>();
    } catch (error: unknown) {
        logger.warn({ error }, "update case failed");
        throw error;
    }
};
